import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function About() {
  const { t } = useTranslation()

  const valueIcons = {
    lightbulb: (
      <svg className="w-10 h-10 md:w-12 md:h-12 text-[#E2725B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    star: (
      <svg className="w-10 h-10 md:w-12 md:h-12 text-[#FFDB58]" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ),
    shield: (
      <svg className="w-10 h-10 md:w-12 md:h-12 text-[#4D5D33]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    rocket: (
      <svg className="w-10 h-10 md:w-12 md:h-12 text-[#E2725B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    )
  }

  const values = [
    {
      id: 1,
      icon: valueIcons.lightbulb,
      title: t('about.values.value1.title'),
      description: t('about.values.value1.description')
    },
    {
      id: 2,
      icon: valueIcons.star,
      title: t('about.values.value2.title'),
      description: t('about.values.value2.description')
    },
    {
      id: 3,
      icon: valueIcons.shield,
      title: t('about.values.value3.title'),
      description: t('about.values.value3.description')
    },
    {
      id: 4,
      icon: valueIcons.rocket,
      title: t('about.values.value4.title'),
      description: t('about.values.value4.description')
    }
  ]

  const journeyHighlights = [
    {
      id: 1,
      title: t('about.journey.highlight1.title'),
      description: t('about.journey.highlight1.description'),
      image: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-3.jpg"
    },
    {
      id: 2,
      title: t('about.journey.highlight2.title'),
      description: t('about.journey.highlight2.description'),
      image: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-4.jpg"
    }
  ]

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section
        className="relative min-h-[400px] md:min-h-[500px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(226, 114, 91, 0.85), rgba(226, 114, 91, 0.85)), url('https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/Gemini_Generated_Image_ttbrgettbrgettbr.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {t('about.hero.title')}
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto">
            {t('about.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* About Us Story Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/1000010560.jpg"
                alt={t('about.story.imageAlt')}
                className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover rounded-2xl shadow-2xl"
                style={{ objectPosition: '50% 90%' }}
                crossOrigin="anonymous"
              />
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <div className="mb-6">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-6">
                  {t('about.story.title')}
                </h2>
              </div>

              <div className="space-y-6">
                <p className="text-base md:text-lg text-[#333333]/80 leading-relaxed">
                  {t('about.story.paragraph1')}
                </p>
                <p className="text-base md:text-lg text-[#333333]/80 leading-relaxed">
                  {t('about.story.paragraph2')}
                </p>
                <p className="text-base md:text-lg text-[#333333]/80 leading-relaxed">
                  {t('about.story.paragraph3')}
                </p>
              </div>

              {/* Stats */}
              <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6">
                <div className="bg-gradient-to-br from-[#E2725B]/10 to-[#FFDB58]/10 rounded-xl p-4 md:p-6 text-center">
                  <div className="text-3xl md:text-4xl font-bold text-[#E2725B] mb-2">
                    {t('about.stats.stat1.number')}
                  </div>
                  <div className="text-sm md:text-base text-[#333333]/70">
                    {t('about.stats.stat1.label')}
                  </div>
                </div>
                <div className="bg-gradient-to-br from-[#E2725B]/10 to-[#FFDB58]/10 rounded-xl p-4 md:p-6 text-center">
                  <div className="text-3xl md:text-4xl font-bold text-[#E2725B] mb-2">
                    {t('about.stats.stat2.number')}
                  </div>
                  <div className="text-sm md:text-base text-[#333333]/70">
                    {t('about.stats.stat2.label')}
                  </div>
                </div>
                <div className="bg-gradient-to-br from-[#E2725B]/10 to-[#FFDB58]/10 rounded-xl p-4 md:p-6 text-center col-span-2 sm:col-span-1">
                  <div className="text-3xl md:text-4xl font-bold text-[#E2725B] mb-2">
                    {t('about.stats.stat3.number')}
                  </div>
                  <div className="text-sm md:text-base text-[#333333]/70">
                    {t('about.stats.stat3.label')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-[#FFDB58]/10 to-[#E2725B]/10">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4">
              {t('about.values.title')}
            </h2>
            <p className="text-base md:text-lg text-[#333333]/70 max-w-2xl mx-auto">
              {t('about.values.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {values.map((value) => (
              <div
                key={value.id}
                className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center hover:scale-105"
              >
                {/* Icon */}
                <div className="flex justify-center mb-4">
                  {value.icon}
                </div>
                {/* Content */}
                <h3 className="text-xl md:text-2xl font-bold text-[#333333] mb-3">
                  {value.title}
                </h3>
                <p className="text-base text-[#333333]/70 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-6">
              {t('about.mission.title')}
            </h2>

            <p className="text-lg md:text-xl text-[#333333]/80 mb-8 leading-relaxed">
              {t('about.mission.text')}
            </p>

            <div className="bg-gradient-to-r from-[#E2725B]/10 to-[#FFDB58]/10 rounded-2xl p-8 md:p-12">
              <blockquote className="text-xl md:text-2xl lg:text-3xl font-bold text-[#E2725B] italic leading-relaxed">
                "{t('about.mission.quote')}"
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* Our Tea Journey Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-[#E2725B]/5 to-[#FFDB58]/5">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4">
              {t('about.journey.title')}
            </h2>
            <p className="text-base md:text-lg text-[#333333]/70 max-w-2xl mx-auto">
              {t('about.journey.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12 max-w-5xl mx-auto">
            {journeyHighlights.map((highlight) => (
              <div
                key={highlight.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <div className="relative h-[300px] md:h-[400px] overflow-hidden">
                  <img
                    src={highlight.image}
                    alt={highlight.title}
                    className="w-full h-full object-cover"
                    crossOrigin="anonymous"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                </div>
                <div className="p-6 md:p-8">
                  <h3 className="text-2xl md:text-3xl font-bold text-[#333333] mb-4">
                    {highlight.title}
                  </h3>
                  <p className="text-base md:text-lg text-[#333333]/70 leading-relaxed">
                    {highlight.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 lg:py-28 bg-gradient-to-r from-[#E2725B] to-[#E2725B]/90">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              {t('about.cta.title')}
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
              {t('about.cta.subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/products"
                className="group w-full sm:w-auto px-10 py-4 bg-white text-[#E2725B] hover:bg-[#FFDB58] hover:text-[#333333] text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-2xl hover:shadow-[#FFDB58]/50 hover:scale-105 transform"
              >
                <span>{t('about.cta.secondaryButton')}</span>
                <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              <Link
                to="/contact"
                className="group w-full sm:w-auto px-10 py-4 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E2725B] text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-xl hover:scale-105 transform"
              >
                <span>{t('about.cta.button')}</span>
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 flex flex-wrap justify-center items-center gap-6 md:gap-8">
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('about.cta.badge1')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('about.cta.badge2')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('about.cta.badge3')}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
